import React from 'react';

interface AudioWaveProps {
  isRecording: boolean;
}

const AudioWave: React.FC<AudioWaveProps> = ({ isRecording }) => {
  return (
    <div className={`audio-wave ${isRecording ? 'recording' : ''}`}>
      {[...Array(10)].map((_, i) => (
        <div key={i} className="wave-bar" style={{ animationDelay: `${i * 0.1}s` }} />
      ))}
    </div>
  );
};

export default AudioWave;
